import { useContext } from 'react';
import Providers from '../Providers';

const { voltaAlertContext, voltaDialogContext } = Providers;

const useVoltaAlert = () => useContext(voltaAlertContext);
const useVoltaDialog = () => useContext(voltaDialogContext);

export { useVoltaAlert, useVoltaDialog };
